import { render, staticRenderFns } from "./Warning.vue?vue&type=template&id=a89922bc"
import script from "./Warning.vue?vue&type=script&lang=js"
export * from "./Warning.vue?vue&type=script&lang=js"
import style0 from "./Warning.vue?vue&type=style&index=0&id=a89922bc&prod&lang=css"
import style1 from "./Warning.vue?vue&type=style&index=1&id=a89922bc&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports